// Deve acompanhar MIN_SENHA_LENGTH em backend/src/utils/senha.ts.
export const MIN_SENHA_LENGTH = 8;
